import React, {Component} from 'react';
import {Row, Col, Form, FormGroup, ControlLabel, Radio, FormControl} from "react-bootstrap";
import {TopSelect} from "../../../../../componentsTopsa/selects/TopSelects";
import TopIf from "../../../../../componentsTopsa/if/TopIf";
import TopDostepnosc from "../../../../../componentsTopsa/dostepnosc/TopDostepnosc";
import {TopButtonAction} from "../../../../../componentsTopsa/buttons/TopButtons";
import {TopInputDate} from "../../../../../componentsTopsa/inputs/TopInputs";
import moment from 'moment'
import ValidatorMessages from "../../../../../shared/validatorMessages/ValidatorMessages";
import Validator from "../../../../../utilities/Validator";
import CennikBiletowService from "../CennikBiletowService";
import DateAndTimeFormat from "../../../../../utilities/DateAndTimeFormat";
import {TopAlertOstrzezenie, TopAlertSukces, TopAlertUwaga} from "../../../../../componentsTopsa/alerty/TopAlerts";

export default class GenerujCennikContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            trasa: null,
            znizka: null,
            waznyOd: moment(),
            wspolczynnik: 1,
            czyWszystkieAktywneTrasy: true,
            validatorMessages: [],
            wiadomoscPoWygenerowaniu: '',
            trwaGenerowanie: false,
            znizkiFilter: this.props.znizki,
            datyBase: [],
            datyBasem: [],
            wyborDatyZSelect: null,
            dataSelect: null,
        }

        this.onClickGeneruj = this.onClickGeneruj.bind(this)
        this.onChangeWaznyOd = this.onChangeWaznyOd.bind(this)
        this.onChangeCzyWszystkieAktywneTrasy = this.onChangeCzyWszystkieAktywneTrasy.bind(this)
        this.onChangeTrasa = this.onChangeTrasa.bind(this)
        this.onChangeZnizka = this.onChangeZnizka.bind(this)
        this.onChangeWspolczynnik = this.onChangeWspolczynnik.bind(this)
        this.formatZnizkaSelect = this.formatZnizkaSelect.bind(this)
        this.onChangeWaznyOdSelect = this.onChangeWaznyOdSelect.bind(this)
    };

    componentDidMount() {
        this.setState({znizkiFilter: this.props.znizki})
    }

    onChangeWaznyOd(e) {
        this.setState({waznyOd: e})
    }

    onChangeCzyWszystkieAktywneTrasy(e) {
        this.setState({czyWszystkieAktywneTrasy: e})
    }

    onChangeWspolczynnik(e) {
        this.setState({wspolczynnik: e.target.value})
    }

    onChangeTrasa(e) {
        let arr = []
        if (e !== null) {
            arr = this.props.znizki.filter(z => z.idTr === 0 || z.idTr === e.idTr)
        }
        else {
            arr = this.props.znizki
        }
        this.setState({trasa: e, znizkiFilter: arr, znizka: null, wyborDatyZSelect: null, dataSelect: null})
    }

    onChangeZnizka(e) {
        this.setState({znizka: e, wyborDatyZSelect: null, dataSelect: null})

        if (e.rodz !== 'BASE' && e.rodz !== 'BASEM') {
            if (e.czyMies) {
                this.pobierzDatyCennikowBazowych(this.state.trasa, 'BASEM')
            }
            else {
                this.pobierzDatyCennikowBazowych(this.state.trasa, 'BASE')
            }
        }
    }

    pobierzDatyCennikowBazowych(trasa, znizka) {
        this.setState({wyborDatyZSelect: znizka})
        CennikBiletowService.pobierzDatyCennikow(trasa.idTr, znizka).then(function (response) {
            if (response) {

                let arr = []

                for (let i = 0; i < response.data.length; i++) {
                    arr.push({value: response.data[i], label: response.data[i]})
                }

                if (znizka === 'BASEM') {
                    this.setState({
                        datyBase: [],
                        datyBasem: arr,
                        dataSelect: arr[arr.length - 1]
                    })
                } else {
                    this.setState({
                        datyBasem: [],
                        datyBase: arr,
                        dataSelect: arr[arr.length - 1]
                    })
                }
            }
        }.bind(this))
    }

    onChangeWaznyOdSelect(e) {
        this.setState({dataSelect: e})
    }

    formatTrasaSelect(option) {
        return <div><span className={'label label-ebus-primary'}>{option.kodTrasy}</span> {option.nazTr}
            <TopDostepnosc wartoscWarunek={0}
                           wartosc={option.status}
                           czyMarginesLewy={true}
            />
        </div>
    }

    formatZnizkaSelect(option) {
        let dlatrasy = 'wszytskie trasy'
        if (option.idTr > 0) {
            let tr = this.props.trasy.find(t => t.idTr === option.idTr)
            if (Boolean(tr)) {
                dlatrasy = tr.nazTr
            }
        }

        return <div><span
            className={'label label-ebus-default'} style={{color:'#fff', background:option.kolor}}>{option.rodz}</span> {option.nazZniz}
            <div className={'pull-right'} style={{fontSize: '12px'}}>
                <span style={{marginRight: '5px'}}>
                    {Boolean(option.czyMies) ? '(M)' : '(J)'}
                </span>
                <span style={{color: 'grey', marginRight: '5px'}}>{dlatrasy}</span>
                {
                    Boolean(option.esprzedaz) ?
                        <span title='Dostępny w esprzedaży' style={{color: 'forestgreen'}}><i className={'fa fa-check'}></i> esprzedaż</span>
                        :
                        <span title='Zablokowany w esprzedaży' style={{color: 'firebrick'}}><i className={'fa fa-times'}></i> esprzedaż</span>
                }
            </div>
        </div>
    }

    dodajDoValidatorMessages(msg) {
        let arr = this.state.validatorMessages;
        arr.push(msg)
        this.setState({validatorMessages: arr})
    }

    onClickGeneruj() {
        this.setState({validatorMessages: [], wiadomoscPoWygenerowaniu: ''})

        let poprawne = true;
        this.state.validatorMessages = [];

        if (!this.state.czyWszystkieAktywneTrasy && !Boolean(this.state.znizka)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Zniżka nie jest wybrana')
        }

        if (!Boolean(this.state.waznyOd) && !Boolean(this.state.wyborDatyZSelect)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Pole ważny do jest wymagane')
        }

        if (Boolean(this.state.wyborDatyZSelect) && !Boolean(this.state.dataSelect)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Pole ważny do jest wymagane')
        }

        if (this.state.wspolczynnik.length == 0) {
            poprawne = false;
            this.dodajDoValidatorMessages('Współczynnik nie jest podany')
        }
        else {
            if (!Validator.validateIntOrDouble(this.state.wspolczynnik)) {
                poprawne = false;
                this.dodajDoValidatorMessages('Współczynnik musi być liczbą nieujemną')
            }
        }

        if (!this.state.czyWszystkieAktywneTrasy && !Boolean(this.state.trasa)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Proszę podać konkretną trasę')
        }

        if (poprawne) {
            this.state.validatorMessages = [];
            this.setState({validatorMessages: [], trwaGenerowanie: true})
            if (this.state.czyWszystkieAktywneTrasy) {

                CennikBiletowService.generujCennikDlaWszystkichAktywnych(this.state.wspolczynnik, DateAndTimeFormat.formatYYYYMMDD(this.state.waznyOd)).then(function (response) {
                    if (response) {
                        if (response.status < 300) {
                            this.setState({wiadomoscPoWygenerowaniu: 'Pomyślnie wygenerowano cennik'})
                        }
                        else {
                            this.setState({wiadomoscPoWygenerowaniu: 'Wystąpił błąd podczas generowania cennika'})
                        }
                    }
                    else {
                        this.setState({wiadomoscPoWygenerowaniu: 'Wystąpił błąd podczas generowania cennika'})
                    }
                    this.setState({trwaGenerowanie: false})
                }.bind(this)).catch(err => {
                    console.error(err);
                    this.setState({wiadomoscPoWygenerowaniu: 'Wystąpił błąd podczas generowania cenników'})

                })

            }
            else {

                CennikBiletowService.generujCennikDlaKonkretnejTrasy(this.state.wspolczynnik, (Boolean(this.state.wyborDatyZSelect)) ? this.state.dataSelect.value : DateAndTimeFormat.formatYYYYMMDD(this.state.waznyOd), this.state.znizka.rodz, this.state.trasa.idTr).then(function (response) {
                    if (response) {
                        if (response.status < 300) {
                            this.setState({wiadomoscPoWygenerowaniu: 'Pomyślnie wygenerowano cennik'})
                        }
                        else {
                            this.setState({wiadomoscPoWygenerowaniu: 'Wystąpił błąd podczas generowania cennika'})
                        }
                    }
                    else {
                        this.setState({wiadomoscPoWygenerowaniu: 'Wystąpił błąd podczas generowania cennika'})
                    }
                    this.setState({trwaGenerowanie: false})

                }.bind(this)).catch(err => {
                    console.error(err);
                    this.setState({wiadomoscPoWygenerowaniu: 'Wystąpił błąd podczas generowania cennika'})
                })

            }
        }
    }

    render() {

        return (
            <div>
                <Row>
                    <Col xs={12}>
                        <Form horizontal={true}>
                            <FormGroup>
                                <Col xs={12}>
                                    <Radio name="radioGroup" horizontal checked={Boolean(this.state.czyWszystkieAktywneTrasy)}
                                           onChange={() => this.onChangeCzyWszystkieAktywneTrasy(true)}>
                                        generuj dla wszystkich aktywnych tras zdefiniowane cenniki
                                    </Radio>
                                    <Radio name="radioGroup" horizontal checked={!Boolean(this.state.czyWszystkieAktywneTrasy)}
                                           onChange={() => this.onChangeCzyWszystkieAktywneTrasy(false)}>
                                        generuj dla konkretnej trasy
                                    </Radio>
                                </Col>
                            </FormGroup>
                            <FormGroup>
                                <Col xs={12} lg={2}>
                                    <ControlLabel>Ważny od <span className={'req'}>*</span></ControlLabel>

                                    {
                                        Boolean(this.state.wyborDatyZSelect) ?
                                            <div>
                                                <TopSelect onChange={this.onChangeWaznyOdSelect} value={this.state.dataSelect}
                                                           options={(this.state.wyborDatyZSelect === 'BASE') ? this.state.datyBase : this.state.datyBasem}
                                                           clearable={false}/>
                                                {(this.state.datyBase.length === 0 && this.state.datyBasem.length === 0) ?
                                                    <TopAlertOstrzezenie text={'Brak dat! Należy najpierw wygenerować cenniki BASE/BASEM'}/> : ''
                                                }
                                            </div>
                                            :
                                            <TopInputDate onChange={this.onChangeWaznyOd} value={this.state.waznyOd}/>

                                    }

                                </Col>
                                <Col xs={12} lg={1}>
                                    <ControlLabel>Współczynnik <span className={'req'}>*</span></ControlLabel>
                                    <FormControl type={'number'} onChange={this.onChangeWspolczynnik} defaultValue={1}/>
                                </Col>
                                <Col xs={12} lg={4}>
                                    <TopIf isTrue={this.state.czyWszystkieAktywneTrasy}>
                                        <div className={'add-label-margin'}></div>
                                        <TopButtonAction text={'Generuj'} iconType={'fa fa-money'} btnSize={'medium'} onClick={this.onClickGeneruj}/>
                                    </TopIf>
                                </Col>
                            </FormGroup>
                            <FormGroup>
                                <TopIf isTrue={!this.state.czyWszystkieAktywneTrasy}>
                                    <Col xs={12} lg={6}>
                                        <div>
                                            <ControlLabel>Trasa <span className={'req'}>*</span></ControlLabel>
                                            <TopSelect onChange={this.onChangeTrasa} value={this.state.trasa} options={this.props.trasy}
                                                       valueKey={'idTr'} labelKey={'nazTr'}
                                                       valueRenderer={this.formatTrasaSelect} optionRenderer={this.formatTrasaSelect}
                                                       placeholder={'Wybierz trasę...'} clearable={false}
                                            />
                                        </div>
                                        <div>
                                            <ControlLabel>Rodzaj cennika <span className={'req'}>*</span></ControlLabel>
                                            <TopSelect onChange={this.onChangeZnizka} value={this.state.znizka} options={this.state.znizkiFilter}
                                                       valueKey={'idZn'} labelKey={'rodz'}
                                                       valueRenderer={this.formatZnizkaSelect} optionRenderer={this.formatZnizkaSelect}
                                                       placeholder={'Wybierz cennik...'} clearable={false} disabled={!Boolean(this.state.trasa)}
                                            />
                                        </div>
                                        <div>
                                            <div className={'pull-right'} style={{marginTop: '5px'}}>
                                                <TopButtonAction text={'Generuj'} iconType={'fa fa-money'} btnSize={'medium'}
                                                                 onClick={this.onClickGeneruj}/>
                                            </div>
                                        </div>
                                    </Col>
                                </TopIf>
                            </FormGroup>
                            <FormGroup>
                                <ValidatorMessages messages={this.state.validatorMessages}/>
                            </FormGroup>
                        </Form>
                    </Col>
                    <Col xs={12} lg={3}>
                        <TopIf isTrue={this.state.trwaGenerowanie}>
                            <div id={'smallLoader'}>
                                <i className={'fa fa-circle-o-notch fa-spin'}></i>
                                <div>Trwa generowanie...</div>
                            </div>
                        </TopIf>
                    </Col>
                    <Col xs={12}>
                        <TopIf isTrue={this.state.wiadomoscPoWygenerowaniu.indexOf('Pomyślnie') > -1}>
                            <TopAlertSukces text={this.state.wiadomoscPoWygenerowaniu}/>
                        </TopIf>
                        <TopIf isTrue={this.state.wiadomoscPoWygenerowaniu.indexOf('błąd') > -1}>
                            <TopAlertUwaga text={this.state.wiadomoscPoWygenerowaniu}/>
                        </TopIf>
                    </Col>
                </Row>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/cenyBiletow/generujCennik/GenerujCennikContainer.js